// extracted by mini-css-extract-plugin
module.exports = {"initializer":"ApplicationInitialization_initializer__3UXfT","content":"ApplicationInitialization_content__OD3Vm","loader":"ApplicationInitialization_loader__3TiiQ"};